import React,{useState,useEffect,useRef}  from 'react';
import { getAllReportsDetails } from '../../redux/actions/reportActions';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, Grid} from '@mui/material';
import './Styles.scss';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';  

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import axios from 'axios';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ConfirmDialog from '../ConfirmDialog';
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

function PatientInfoComp() {
    const dispatch= useDispatch();
  const { all_users,auth_token,user } = useSelector((state) => state.auth);
  const { all_reports } = useSelector((state) => state.report);
  
  const [role, setRole] = useState([]);
  const [formData, setFormData] = useState({
    "firstName": "",
    "lastName": "",
    "email": "",
    "status": false,
    "role": "ROLE_ADMIN"
  });

  const [open, setOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const openEl = Boolean(anchorEl);
  const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
  };
  const handleCloseEl = () => {
      setAnchorEl(null);
  };
  const handleActionClick = (evt, option) => {
      setSelectedOption(option);
      
      if(option === "Delete"){
          setConfirmDialogOpen(true);
      }else if(option === "Edit"){
          // Edit logic will be implemented later
      }
      setAnchorEl(null);
  };

  const handleConfirmDelete = () => {
      setConfirmDialogOpen(false);
  };

  const handleCancelDelete = () => {
  setConfirmDialogOpen(false);
  };
  const options = [
     "Delete",
  ];
  const ITEM_HEIGHT = 48;
  const isFetched = useRef(false);
    useEffect(()=>{
      if (auth_token && !isFetched.current) {
        isFetched.current = true;
      }
    },[auth_token])

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleChange = (event) => {
    setFormData({
        ...formData,
        "role": event.target.value,
      });
  };
  const columns = [
    { field: 'clientName', headerName: 'Client',flex: 1, headerClassName: 'bold-header'/*  width: 280 */ },
    { field: 'lastSessionSeen', headerName: 'Last Session Seen', flex: 1,headerClassName: 'bold-header'/* width: 280 */ },
    { field: 'tx_plan', headerName: 'TX Plan', flex: 1,headerClassName: 'bold-header'/* width: 280 */ },
    { field: 'created_by', headerName: 'Created By', flex: 1,headerClassName: 'bold-header'/* width: 200, */},
    { headerName: 'Action',flex: 1 ,headerClassName: 'bold-header'/* width: 100 */, 
    renderCell: (params) => {
      // Conditionally display status text
      
        return (
            <>
               
                {
                user&& user.role==='ROLE_ADMIN'?
                <div>
                <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={openEl ? 'long-menu' : undefined}
                    aria-expanded={openEl ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    id="long-menu"
                    MenuListProps={{
                    'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorEl}
                    open={openEl}
                    onClose={handleCloseEl}
                    slotProps={{
                    paper: {
                        style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch',
                        },
                    },
                    }}
                >
                    {options.map((option) => (
                    <MenuItem key={option} selected={option === 'Pyxis'} onClick={(e) => handleActionClick(e, option)} >
                        {option}
                    </MenuItem>
                    ))}
                </Menu>
                
                </div>
                :""}
            </>
        );
    },
    },
   
  ];
  
  
  const paginationModel = { page: 0, pageSize: 5 };
  const rows = [
    { "id": 1, "clientName": "Snow Report", "lastSessionSeen": "2024-11-25", "created_by": 14 },
    { "id": 2, "clientName": "Rain Analysis", "lastSessionSeen": "2024-11-24", "created_by": 21 },
    { "id": 3, "clientName": "Wind Speed Study", "lastSessionSeen": "2024-11-23", "created_by": 14 },
    { "id": 4, "clientName": "Temperature Trends", "lastSessionSeen": "2024-11-22", "created_by": 18 },
    { "id": 5, "clientName": "Humidity Insights", "lastSessionSeen": "2024-11-21", "created_by": 19 },
    { "id": 6, "clientName": "Climate Change Impact", "lastSessionSeen": "2024-11-20", "created_by": 25 },
    { "id": 7, "clientName": "Air Quality Index", "lastSessionSeen": "2024-11-19", "created_by": 22 },
    { "id": 8, "clientName": "Flood Risk Assessment", "lastSessionSeen": "2024-11-18", "created_by": 14 },
    { "id": 9, "clientName": "Drought Monitoring", "lastSessionSeen": "2024-11-17", "created_by": 20 },
    { "id": 10, "clientName": "Wildfire Analysis", "lastSessionSeen": "2024-11-16", "created_by": 18 }
  ];
  return (
    <>
    <ConfirmDialog
      open={confirmDialogOpen}
      title="Confirm Delete"
      message="Are you sure you want to Delete?"
      onConfirm={handleConfirmDelete}
      onCancel={handleCancelDelete}
      buttonLoading={false}
    />
    <Box className="rightContainer">
    <Grid container spacing={2}>
        <Grid item xs={6}>
            <Typography component="h1" variant="h5" mb={2}>
            Patient Info
            </Typography>
        </Grid>
        <Grid item xs={6}>
            {/* <Item className='text-right'><Button
                variant={'contained'}
                sx={{ marginBottom:"5px" }}
                onClick={handleClickOpen}
                 > Generate Report</Button></Item> */}
        </Grid>
    </Grid>


      <Paper sx={{ height: 500, width: '100%' }}>
          <DataGrid
              rows={rows}
              columns={columns}
              initialState={{ pagination: { paginationModel } }}
              pageSizeOptions={[5, 10]}
              checkboxSelection={false}
              sx={{ 
                '& .MuiDataGrid-columnHeader': {
                  backgroundColor: 'rgba(0, 0, 0, 0)', 
                  color: 'black', 
                  fontSize: '16px', 
                },
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#dee7de', 
                  color: 'black', 
                  fontSize: '16px', 
                },
                '& .MuiDataGrid-row--borderBottom': {
                  backgroundColor: 'rgba(0, 0, 0, 0) !important', 
                  color: 'black', 
                  fontSize: '16px', 
                },
                border: 0 
              }}
              autoPageSize={true}
          />
      </Paper>
      
    </Box>
    <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={"sm"}
        fullWidth={true}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "20px",
          },
        }}
      >
        <Box sx={{padding:'10px'}} >
        <DialogTitle>Select Columns</DialogTitle>
        <DialogContent>
          <FormGroup>
            <FormControlLabel control={<Checkbox defaultChecked />} label="Clients" />
            <FormControlLabel control={<Checkbox defaultChecked />} label="Insurance" />
            <FormControlLabel control={<Checkbox defaultChecked />} label="Last Session Seen" />
            <FormControlLabel control={<Checkbox defaultChecked />} label="TX Plan" />
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button variant={'outlined'} onClick={handleClose}>Cancel</Button>
          <Button variant={'contained'} type="button" onClick={handleClose} >Generate</Button>
         
        </DialogActions>
        </Box>
      </Dialog>
    </>
    
  );
}

export default PatientInfoComp;
